import { useEffect } from "react";
import { getParserConfigList } from "../../../services/parserConfigService";
import { getDeviceTypeList, createDevice } from "../../../services/deviceService";
import { getMyDeviceGroupListForForm } from "../../../services/deviceGroupService";
import { fetchList } from "../../../utils/fetchList";
import { useDeviceFormState, DeviceFormErrors, DeviceGroupOption } from "./useDeviceFormState";

export const useDeviceCreate = (open: boolean) => {
  const form = useDeviceFormState();
  const { selectedDeviceType, setParserConfigs, setSelectedParserConfig } = form;

  useEffect(() => {
    if (!open) return;
    fetchList(getDeviceTypeList, form.setDeviceTypes);
    const loadGroups = async () => {
      const res = await getMyDeviceGroupListForForm();
      if (res.data.success) {
        const groups: DeviceGroupOption[] = (res.data.data as any[])
          .filter((g: any) => g.canCreate === true)
          .map((g: any) => ({ id: g.id, name: g.name }));
        form.setDeviceGroups(groups);
      }
    };
    loadGroups().catch(console.error);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    if (selectedDeviceType) {
      fetchList(() => getParserConfigList(selectedDeviceType.id), setParserConfigs);
    } else {
      setParserConfigs([]);
      setSelectedParserConfig(null);
    }
  }, [selectedDeviceType, open]);

  const handleCreate = async () => {
    const { deviceName, serialNumber, selectedParserConfig, description, iconId, selectedDeviceGroup } = form;
    const errs: DeviceFormErrors = {};
    if (!deviceName.trim()) errs.deviceName = "Cihaz adı boş olamaz.";
    else if (deviceName.trim().length > 150) errs.deviceName = "Cihaz adı en fazla 150 karakter olabilir.";
    if (!serialNumber.trim()) errs.serialNumber = "Seri numarası boş olamaz.";
    else if (serialNumber.trim().length > 150) errs.serialNumber = "Seri numarası en fazla 150 karakter olabilir.";
    if (!selectedDeviceType) errs.selectedDeviceType = "Cihaz tipi seçiniz.";
    if (!selectedParserConfig) errs.selectedParserConfig = "Parser seçiniz.";
    if (Object.keys(errs).length > 0) { form.setErrors(errs); throw new Error(""); }

    form.setErrors({});
    const response = await createDevice({
      deviceName,
      description,
      serialNumber,
      parserConfigId: selectedParserConfig!.id,
      deviceTypeId: selectedDeviceType!.id,
      iconId,
      deviceGroupId: selectedDeviceGroup?.id ?? null,
    });

    if (!response.data.success) throw new Error(response.data.message);
    return response.data.message;
  };

  return { ...form, handleCreate };
};
